import React, { useRef, useState } from 'react'
import { GameCssStyles } from '../GameCssStyles'
import { Box, Button, TextField, Typography } from '@mui/material'
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker'
import dayjs from 'dayjs'
import { getSingleFileByNameFromAWSS3Bucket, uploadFileToAWSS3Bucket } from '../../../services/uploadFileOnAWS_S3_Bucket'

const SponseredBy = ({ formGameData, setFormGameData, handleChange }) => {

    const fileInputRef = useRef(null);

    const handleGameBannerChnageUploadImageBTClick = () => {
        fileInputRef.current.click();
    }

    const handleGameBannerFileChange = async (event) => {
        const file = event.target.files[0];
        if (file) {
            const url = URL.createObjectURL(file);
            const mimeType = file.type;
            var type = "unknown";
            if (mimeType.startsWith("image/")) {
                type = "image";
            }
            console.log("File selected:", file, "URL:", url, "Type:", type);
            const result = await uploadFileToAWSS3Bucket("banners", file);
            console.log("Upload AWS result : ", result)
            const fileResult = await getSingleFileByNameFromAWSS3Bucket("banners", result?.key?.split('/').pop());
            console.log("Single File AWS fileResult : ", fileResult)
            handleChange("sponser.banner", fileResult);
        }
        else {
            console.error("No file selected");
            handleChange("sponser.banner", "");
        }
    }

    const createDateInMilliseconds = (path) => {
        const currentDate = new Date();
        const transformedDate = dayjs(currentDate);
        const milliseconds = transformedDate.valueOf();
        handleChange(path, milliseconds);
        return transformedDate;
    }

    return (
        <Box sx={GameCssStyles.containerStyleColumn_sx}>
            <Typography variant="h6" fontWeight={600} mb={0} alignSelf={"start"} justifySelf={'start'}>Sponsered By</Typography>
            <Box display="flex" alignItems="stretch" gap={3} mt={0} width="100%">
                <TextField
                    fullWidth
                    label="Name"
                    multiline={false}
                    rows={1}
                    value={formGameData?.sponser?.name || ''}
                    onChange={(e) => { handleChange("sponser.name", e.target.value) }}
                    sx={GameCssStyles.formSingleLineTextField_sx}
                />
            </Box>

            <Box background={"#f4f1f9"} display="flex" flex={1} flexDirection="row" gap={3} mt={3}>
                <TextField
                    fullWidth
                    label="Sponser Banner URL"
                    multiline={false}
                    rows={1}
                    value={formGameData?.sponser?.banner || ''}
                    onChange={(e) => handleChange("sponser.banner", e.target.value)}
                    sx={GameCssStyles.formSingleLineTextField_sx}
                />
                <>
                    <input
                        type="file"
                        accept="image/*"
                        ref={fileInputRef}
                        style={{ display: "none" }}
                        onChange={handleGameBannerFileChange}
                    />
                    <Button
                        variant="contained"
                        color="secondary"
                        sx={{ height: "100%" }}
                        onClick={handleGameBannerChnageUploadImageBTClick}
                    >
                        {formGameData?.sponser?.banner ? "Change" : "Upload"}
                    </Button>
                </>
            </Box>

        </Box>
    )
}

export default SponseredBy
